import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { deleteUserVariantEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const deleteVariantAPI = createApi(deleteUserVariantEndpoint, "DELETE");

const deleteVariantSlice = createSlice({
  name: "DeleteVariantSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteVariantAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVariantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteVariantAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deleteVariantSlice.reducer;
